import { getCompleteRut } from '~utils/rut';

export const getCurrentRut = (currentClient, currentGuarantor) => ({
  client: getCompleteRut(currentClient?.rut, currentClient?.dv),
  guarantor: getCompleteRut(currentGuarantor?.rut, currentGuarantor?.dv)
});
